import { render } from "./device_page.vue?vue&type=template&id=a2bf6b00&scoped=true"
import script from "./device_page.vue?vue&type=script&lang=js"
export * from "./device_page.vue?vue&type=script&lang=js"

import "./device_page.vue?vue&type=style&index=0&id=a2bf6b00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2bf6b00"]])

export default __exports__